import { ADD_FAVORITE_SUCCEEDED, REMOVE_FAVORITE_SUCCEEDED } from '../../../redux/favorites';
import { useDispatch } from 'react-redux';
// @ts-expect-error Untyped import
import { ReportingTracker } from '../../../lib/usageTracker';
import { isBaseReport } from 'reporting-data/tsTypes/reportTypes';
import { FAVORITE_ACTION_LOCATIONS } from 'reporting-action-components/reportingActions/favoriteAsset/constants';
import FavoriteReportButton from 'reporting-action-components/reportingActions/favoriteAsset/FavoriteReportButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportFavoriteButton = ({
  report
}) => {
  const dispatch = useDispatch();
  return isBaseReport(report) ? /*#__PURE__*/_jsx(FavoriteReportButton, {
    actionLocation: FAVORITE_ACTION_LOCATIONS.ASSET_LIST_PAGE,
    appUsageTracker: ReportingTracker,
    onAddFavoriteSuccess: reportId => {
      dispatch({
        type: ADD_FAVORITE_SUCCEEDED,
        payload: reportId
      });
    },
    onRemoveFavoriteSuccess: reportId => {
      dispatch({
        type: REMOVE_FAVORITE_SUCCEEDED,
        payload: reportId
      });
    },
    report: report
  }) : null;
};